import React, { forwardRef } from 'react';
import './Input.css';

const Input = forwardRef(({ 
  label,
  error,
  helperText,
  leftIcon,
  rightIcon,
  className = '',
  ...props 
}, ref) => {
  return (
    <div className={`ui-input-wrapper ${className}`}>
      {label && (
        <label className="ui-input-label">
          {label}
          {props.required && <span className="ui-input-required">*</span>}
        </label>
      )}
      <div className="ui-input-container">
        {leftIcon && <span className="ui-input-icon ui-input-icon--left">{leftIcon}</span>}
        <input
          ref={ref}
          className={`ui-input ${error ? 'ui-input--error' : ''} ${leftIcon ? 'ui-input--with-left-icon' : ''} ${rightIcon ? 'ui-input--with-right-icon' : ''}`}
          {...props}
        />
        {rightIcon && <span className="ui-input-icon ui-input-icon--right">{rightIcon}</span>}
      </div>
      {error && <p className="ui-input-error">{error}</p>}
      {helperText && !error && <p className="ui-input-helper">{helperText}</p>}
    </div>
  );
});

Input.displayName = 'Input';

export default Input;
